import React, { useState } from 'react';
import auth from '../AuthService';

export default function Verify2FA() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const tempToken = auth.getTempToken();

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await auth.loginWith2FA(tempToken, code);
      if (res.token) {
        auth.clearTempToken();
        window.location.replace('/');
      } else {
        setError('Invalid code. Please try again.');
      }
    } catch (err) {
      setError(err.message || '2FA verification failed');
    } finally {
      setLoading(false);
    }
  };

  if (!tempToken) {
    window.location.replace('/');
    return null;
  }

  return (
    <div className="center">
      <div className="card">
        <h1>Two-Factor Authentication</h1>
        <p>Enter the 6-digit code from your authenticator app.</p>
        <form onSubmit={handleVerify}>
          <input
            className="form-item"
            placeholder="6-digit code..."
            type="text"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
          />
          {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
          <input className="form-submit" value={loading ? 'Verifying...' : 'Verify'} type="submit" disabled={loading || code.length !== 6} />
        </form>
      </div>
    </div>
  );
}
